export default {
      id: "icon-diamant-usage",
      viewBox: "0 0 124.1 99.3",
      url: __webpack_public_path__ + "icons.svg#icon-diamant",
      toString: function () {
        return this.url;
      }
    }